<template>
<label class="switch">
  <input type="checkbox" :checked="toggled">
  <span class="slider"></span>
  <span class="bg"></span>
</label>
</template>

<script>

export default {
  name: 'Toggle',
  data() {
    return {
      hasAutofill: this.autofill,
      inputValue: this.value,
    };
  },
  props: {
    toggled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Toggle.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/formElements/Toggle/Toggle.vue